import React, { useState, useEffect } from "react";
import { Panel } from "rsuite";
import { IoAddOutline, IoPencilOutline } from "react-icons/io5";
import EditBlog from '../../components/blog-edit';
import BlogMediaSwiper from "../BlogMediaSwiper.js"
import services from "../../services";
import "./styles.css";

const BlogsManage = () => {
  const [displayBlogView, setDisplayBlogView] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);

  const { data, isLoading, refetch } = services.blogs.useBlogs({
    pageNumber: 1,
    pageSize: 50,
    userId: 104
  });

  useEffect(() => {
    if (!displayBlogView) {
      refetch();
    }
  }, [displayBlogView, refetch]);

  const blogData = data?.blogs || [];

  return (
    <div className="mb-8">
      {!displayBlogView ? (
        <>
          <div className="addButtonContainer">
            <button
              onClick={() => {
                setSelectedBlog(null);
                setDisplayBlogView(true);
              }}
              className="btnftn tab-button"
            >
              <IoAddOutline color="white" />
              Add blog
            </button>
          </div>

          <div className="columns-2 relative mt-5">
            {isLoading && <div className="loader">Loading...</div>}
            {blogData.map((blogItem) => (
            <Panel
              key={blogItem.id}
              shaded
              bordered
              bodyFill
              className="mb-3 relative"
            >
              <button
                onClick={() => {
                  setSelectedBlog(blogItem);
                  setDisplayBlogView(true);
                }}
                className="rounded-full w-[40px] h-[40px] m-2 flex absolute top-2 right-2 justify-center items-center bg-[#2D9687] z-10"
              >
                <IoPencilOutline size={20} color="white" />
              </button>
              <BlogMediaSwiper blogItem={blogItem}/>
              <Panel className="h-[300px] overflow-y-auto" header={blogItem.blogTitle}>
                <div dangerouslySetInnerHTML={{ __html: blogItem.blogText }} />
              </Panel>
            </Panel>

            ))}
          </div>
        </>
      ) : (
        <EditBlog blogData={selectedBlog} setDisplayBlogView={setDisplayBlogView} />
      )}
    </div>
  );
};

export default BlogsManage;